module.exports = __webpack_public_path__ + "img/ic_android.05481d09.svg";